import { saveObjectToSessionStorage } from './helpers';

const saveFormStateToSessionStorage = (formId) => (formState) => {
  const values = { ...formState.values };

  saveObjectToSessionStorage(formId, values);
};

export default saveFormStateToSessionStorage;
